var React = require('react');

function TreeBgShape (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Path 4"),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("polygon",{"id":"Path-4","fill":"#EAC059","points":"0.0479285391 6.33171349 227.69075 205.417995 227.69075 458.925971 1430.03755 458.925971 1454.0519 520.474119 1610 520.474119 1610 0.447050493 0.0479285391 0.447050493"}))]);
}

TreeBgShape.defaultProps = {"viewBox":"0 0 1610 521","version":"1.1"};

module.exports = TreeBgShape;

TreeBgShape.default = TreeBgShape;
